import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faCheckCircle, faTimesCircle, faCar } from '@fortawesome/free-solid-svg-icons';
import { getEstadisticas } from '../../services/api';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const data = await getEstadisticas();
      setStats(data);
    } catch (err) {
      setError('Error al cargar estadisticas');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="dashboard-loading">Cargando estadisticas...</div>;
  }

  if (error) {
    return <div className="dashboard-error">{error}</div>;
  }

  const successRate = stats.total_consultas > 0
    ? ((stats.consultas_exitosas / stats.total_consultas) * 100).toFixed(1)
    : 0;

  return (
    <div className="dashboard">
      <h1 className="dashboard-title">Dashboard</h1>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon total">
            <FontAwesomeIcon icon={faChartBar} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{stats.total_consultas}</span>
            <span className="stat-label">Total Consultas</span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon success">
            <FontAwesomeIcon icon={faCheckCircle} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{stats.consultas_exitosas}</span>
            <span className="stat-label">Consultas Exitosas</span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon failed">
            <FontAwesomeIcon icon={faTimesCircle} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{stats.consultas_fallidas}</span>
            <span className="stat-label">Consultas Fallidas</span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon unique">
            <FontAwesomeIcon icon={faCar} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{stats.patentes_unicas}</span>
            <span className="stat-label">Patentes Unicas</span>
          </div>
        </div>
      </div>

      <div className="dashboard-row">
        <div className="dashboard-card">
          <h2>Tasa de Exito</h2>
          <div className="success-rate">
            <div className="rate-circle">
              <span className="rate-value">{successRate}%</span>
            </div>
            <p className="rate-description">
              {stats.consultas_exitosas} de {stats.total_consultas} consultas exitosas
            </p>
          </div>
        </div>

        <div className="dashboard-card">
          <h2>Consultas por Jurisdiccion</h2>
          <div className="jurisdiccion-list">
            {Object.entries(stats.consultas_por_jurisdiccion || {}).length > 0 ? (
              Object.entries(stats.consultas_por_jurisdiccion).map(([jurisdiccion, count]) => (
                <div key={jurisdiccion} className="jurisdiccion-item">
                  <span className="jurisdiccion-name">{jurisdiccion}</span>
                  <span className="jurisdiccion-count">{count}</span>
                </div>
              ))
            ) : (
              <p className="no-data">Sin datos de jurisdicciones</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
